export default function Loader() {
    return <div className="se-pre-con"></div>
}